import { Component, Input, OnInit } from '@angular/core';
import { GitwiserService } from '@shared/services/gitwiser.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { th } from 'date-fns/locale';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import {AnalysisActivityLogComponent} from '../activity/log/analysis-activity-log.component';
@Component({
    selector: 'app-analysis-activity.component',
    templateUrl: './analysis-activity.component.html'
})
export class AnalysisActivityComponent implements OnInit {
    @Input() analysisId: string;
    @Input() addon: string;
    activities: Base.ActivityModel[] = [];
    listOfType: Base.KeyLabelModel[] = [];
    listOfTypeAnalysis: Base.KeyLabelModel[] = [];
    loading: boolean;
    visible = false;
    selectedType: any;
    selectedAnalysisType: any;
    tempActivities: Base.ActivityModel[] = [];
    ALL_KEY = "ALL";

    

    constructor(private gitwiserService: GitwiserService,private drawerService: NzDrawerService) { }

    async ngOnInit() {
        this.visible = true;
        this.loading = true;

        await this.getActivities();



        this.loading = false;
    }

    async getActivities(): Promise<any> {
        return new Promise(resolve => {
            this.gitwiserService
                .getActivities(this.analysisId)
                .subscribe(
                    (response: any) => {
                        this.activities = response.activities;
                        this.listOfType = response.types;
                        this.listOfTypeAnalysis = response.actionTypes;
                        this.tempActivities = response.activities;

                        const allKey = { key: this.ALL_KEY, label: this.ALL_KEY }
                        this.listOfTypeAnalysis.push(allKey)
                        const type = this.listOfTypeAnalysis.find(f => this.ALL_KEY === f.key)
                        if (type) {
                            this.selectedAnalysisType = type.key;
                        }

                        this.listOfType.push(allKey)
                        const existDefaultBranch = this.listOfType.find(f => this.ALL_KEY === f.key)

                        if (existDefaultBranch) {
                            this.selectedType = existDefaultBranch.key;
                        }

                        this.sort()

                        this.loading = false;
                        resolve(this.activities);
                    },
                    error => {
                        this.loading = false;
                        console.log('error occurred while fetching initial data for gitwiser', error
                        );
                    }
                );
        });
    }

    close(): void {
        this.visible = false;
    }

    filterActivities($event: any, field: string): void {
        this.loading = true;
        if ('selectedAnalysisType' === field) {
            this.selectedAnalysisType = $event;
        }

        if ('selectedType' === field) {
            this.selectedType = $event;
        }

        if (this.ALL_KEY === this.selectedType && this.ALL_KEY !== this.selectedAnalysisType) {
            this.activities = this.tempActivities.filter(f => this.selectedAnalysisType === f.actionType)
        } else if (this.ALL_KEY !== this.selectedType && this.ALL_KEY === this.selectedAnalysisType) {
            this.activities = this.tempActivities.filter(f => this.selectedType === f.type)
        } else if (this.ALL_KEY === this.selectedType && this.ALL_KEY === this.selectedAnalysisType) {
            this.activities = this.tempActivities;
        } else {
            this.activities = this.tempActivities.filter(f => this.selectedAnalysisType === f.actionType && this.selectedType === f.type)
        }
        this.sort()

        this.loading = false;
    }


    sort() {
        this.activities.sort((a, b) => b.actionDate.localeCompare(a.actionDate));
    }

    showConsole(data:any){
        this.drawerService.create({
            nzTitle: `Log of ${data.actionType} -  ${data.actionTime} `,
            nzWidth: '500px',
            nzHeight:'40%',
            nzPlacement: 'bottom' ,
            nzContent: AnalysisActivityLogComponent,
            nzContentParams:{
                data,
            }
          });
    }
    resetForm(): void { }
}
